import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { SaveButton, EditButton } from "components";
import BasicTable from "components/common/BasicTable/BasicTable";
import get from "lodash.get";
import { Grid } from "@mui/material";

const InstructionVideoList = () => {
  const { t } = useTranslation();
  const [render] = useState(false);

  const columns = [
    {
      title: t("COMMON.VIDEO_NAME"),
      renderItem: (item: any) => item.name || "—",
    },
    {
      title: t("COMMON.VIDEO_URL"),
      renderItem: (item: any) => {
        const url = get(item, "url", "");
        if (!url) return "—";
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1976d2", textDecoration: "none" }}
          >
            {url.length > 50 ? url.slice(0, 50) + "…" : url}
          </a>
        );
      },
    },
    {
      title: "",
      renderItem: (item: any) => (
        <Grid container justifyContent="flex-end" alignItems="center">
          <Grid item>
            <EditButton to={`/instruction-video/edit/${item._id}`} />
          </Grid>
        </Grid>
      ),
    },
  ];

  return (
    <div className="container-scroll">
      <div className="mb-3">
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        direction="row"
      >
        <Link to="/instruction-video/add" className="text-decoration-none">
          <SaveButton
            value={t("COMMON.ADD_VIDEO_LESSON")}
            type="button"
            symbol={true}
          />
        </Link>
      </Grid>
      </div>
      <BasicTable
        columns={columns}
        dataUrl="instruction-video"
        render={render}
      />
    </div>
  );
};

export default InstructionVideoList;
